<template>
	<ValidationObserver v-slot="{ failed, valid, invalid, validated, passes, validate, handleSubmit, errors }" ref="observer">
		<v-snackbar
			v-model="failed"
			color="rgb(244, 67, 54)"
			outlined
			timeout="8000"
		>
			{{ $t('validation.errors') }}
			<!--			<template v-slot:action="{ attrs }">-->
			<!--				<v-btn-->
			<!--					text-->
			<!--					v-bind="attrs"-->
			<!--					@click="failed = false"-->
			<!--				>-->
			<!--					X-->
			<!--				</v-btn>-->
			<!--			</template>-->
		</v-snackbar>
		<div class="pa-5 pa-sm-10 fill-height" v-if="AppStore.started_app" id="questions-page">
			<v-container class="fill-height d-flex align-center flex-row">
				<v-row>
					<v-card elevation="0" class="mx-auto py-5  px-2 px-sm-10" rounded="xl">
						<v-col cols="12" class="text-h2 pt-5 pb-7 text-center my-auto"
						       v-if="AppStore.data.configuration.display_question_title">
        						<span v-if="Helpers.isNegativeWithComment()"
						              v-html="AppStore.data.configuration[AppStore.locale].title_3_negative_with_comment"></span>
							<span v-if="Helpers.isNegativeWithoutComment()"
							      v-html="AppStore.data.configuration[AppStore.locale].title_3_negative_without_comment"></span>
							<span v-if="Helpers.isPositiveWithComment()"
							      v-html="AppStore.data.configuration[AppStore.locale].title_3_positive_with_comment"></span>
							<span v-if="Helpers.isPositiveWithoutComment()"
							      v-html="AppStore.data.configuration[AppStore.locale].title_3_positive_without_comment"></span>
						</v-col>

						<v-col cols="12" id="question-questions"
						       v-if="questions_to_display && questions_to_display.length">
							<div v-for="(question, questionIndex) in questions_to_display"
							     :key="questions_to_display[questionIndex].id+AppStore.updatedKey" class="question-question">
								<divider-view v-if="question.format === 'divider'"></divider-view>
								<slider-view v-if="question.format === 'slider' && !questions_to_display[questionIndex].must_be_hide"
								             :rules="question.is_required ? { regex: /^[1-5]+$/ } : ''"
								             v-model="questions_to_display[questionIndex]"
								             :id="'q'+questions_to_display[questionIndex].id"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></slider-view>
								<text-view v-if="question.format === 'text' && !questions_to_display[questionIndex].must_be_hide"
								           :rules="question.regex ? question.is_required ? 'required|regex:'+question.regex : 'regex:'+question.regex : question.is_required ? 'required' : ''"
								           v-model="questions_to_display[questionIndex]"
								           :id="'q'+questions_to_display[questionIndex].id"
								           :questionIndex="questionIndex" :lang="AppStore.locale"></text-view>
								<textarea-view v-if="question.format === 'textarea' && !questions_to_display[questionIndex].must_be_hide"
								               :rules="question.is_required ? 'required' : ''"
								               v-model="questions_to_display[questionIndex]"
								               :id="'q'+questions_to_display[questionIndex].id"
								               :questionIndex="questionIndex" :lang="AppStore.locale"></textarea-view>
								<select-view v-if="question.format === 'select' && !questions_to_display[questionIndex].must_be_hide"
								             :rules="question.is_required ? 'required' : ''"
								             return-object
								             :id="'q'+questions_to_display[questionIndex].id"
								             :name="questions_to_display[questionIndex].name"
								             v-model="questions_to_display[questionIndex]"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></select-view>
								<checkbox-view v-if="question.format === 'checkbox' && !questions_to_display[questionIndex].must_be_hide"
								               :rules="question.is_required ? 'required' : ''"
								               :color="AppStore.data.general.primary_color"
								               :id="'q'+questions_to_display[questionIndex].id"
								               v-model="questions_to_display[questionIndex]"
								               :questionIndex="questionIndex" :lang="AppStore.locale"></checkbox-view>
								<radio-view v-if="question.format === 'radio' && !questions_to_display[questionIndex].must_be_hide"
								            :rules="question.is_required ? 'required' : ''"
								            :color="AppStore.data.general.primary_color"
								            :id="'q'+questions_to_display[questionIndex].id"
								            v-model="questions_to_display[questionIndex]"
								            :questionIndex="questionIndex" :lang="AppStore.locale"></radio-view>
								<switch-view v-if="question.format === 'switch' && !questions_to_display[questionIndex].must_be_hide"
								             :rules="question.is_required ? 'required' : ''"
								             :color="AppStore.data.general.primary_color"
								             :id="'q'+questions_to_display[questionIndex].id"
								             v-model="questions_to_display[questionIndex]"
								             :questionIndex="questionIndex" :lang="AppStore.locale"></switch-view>
							</div>
						</v-col>

						<v-col cols="12" class="text-center">
								<!--								<v-btn-->
								<!--									@click="passes(submit)"-->
								<!--									:large="AppStore.data.general.button_size === 'large'"-->
								<!--									:x-large="AppStore.data.general.button_size === 'x-large'"-->
								<!--									:x-small="AppStore.data.general.button_size === 'x-small'"-->
								<!--									:small="AppStore.data.general.button_size === 'small'"-->
								<!--									v-if="answersLength === answersLengthes"-->
								<!--									@keypress.enter="navigate" role="link" rounded-->
								<!--									outlined elevation="0"-->
								<!--									:color="Helpers.getColor(AppStore.data.general.primary_color.hexa)"-->
								<!--									class="revert-btn text-button"-->
								<!--									:style="Helpers.getButtonSize(AppStore.data.general.button_size)"-->
								<!--									v-html="AppStore.data.configuration[AppStore.locale].skip_btn">-->
								<!--								</v-btn>-->
								<v-btn @click="passes(submit)" role="link" rounded
								       elevation="0" dark
								       :large="AppStore.data.general.button_size === 'large'"
								       :x-large="AppStore.data.general.button_size === 'x-large'"
								       :x-small="AppStore.data.general.button_size === 'x-small'"
								       :small="AppStore.data.general.button_size === 'small'"
								       @keypress.enter="navigate"
								       class="text-button"
								       :color="Helpers.getColor(AppStore.data.general.primary_color.hexa)"
								       :style="Helpers.getButtonSize(AppStore.data.general.button_size)"
								       v-html="AppStore.data.configuration[AppStore.locale].send_btn">
								</v-btn>
						</v-col>
					</v-card>
				</v-row>
			</v-container>
		</div>
	</ValidationObserver>
</template>

<script>
import AppStore from "../../../stores/AppStore";
import _ from "lodash";
import Helpers from "../../../services/Helpers";
import SliderView from '../../../components/communs/inputViewer3/SliderView.vue'
import TextView from '../../../components/communs/inputViewer3/TextView.vue'
import TextareaView from '../../../components/communs/inputViewer3/TextareaView.vue'
import SelectView from '../../../components/communs/inputViewer3/SelectView.vue'
import CheckboxView from '../../../components/communs/inputViewer3/CheckboxView.vue'
import RadioView from '../../../components/communs/inputViewer3/RadioView.vue'
import SwitchView from '../../../components/communs/inputViewer3/SwitchView.vue'
import {EventBus} from "../../../services/Request";
import DividerView from "../../../components/communs/inputViewer3/DividerView.vue";
import {ValidationObserver} from 'vee-validate';

export default {
	name: 'questions-view',

	components: {
		DividerView,
		SliderView,
		TextView,
		TextareaView,
		SelectView,
		CheckboxView,
		RadioView,
		SwitchView,
		ValidationObserver
	},

	props: {},

	data: () => ({
		AppStore,
		Helpers,
		EventBus,
		answersLength: Object.keys(AppStore.rating.questions_answers).length,
		questions: [],
		questions_to_display: [],
	}),

	created() {
		setTimeout(() => {
			this.calculCguHeight()
		}, 300);

		window.addEventListener("orientationchange", () => {
			this.calculCguHeight()
		}, false);

		window.addEventListener("resize", () => {
			this.calculCguHeight()
		}, false);

		EventBus.$on('updateQuestion', (data) => {
			const index = _.findIndex(this.questions_to_display, (q) => {
				return q.id === data.question.id;
			}, 0)
			if (index !== -1){
				let newQuestionToDisplay = Object.assign([], this.questions_to_display)
				newQuestionToDisplay[index] = data.question
				this.questions_to_display = newQuestionToDisplay
			}
		});
	},

	async mounted() {
		this.questions = []
		this.questions_to_display = []
		await this.getBookmarkedQuestions()
		if (AppStore.questions_by_page[4] && AppStore.questions_by_page[4].length > AppStore.data.configuration.questions_to_display_4) {
			await this.getRandomQuestions();
		} else {
			this.questions = Object.assign([], _.filter(AppStore.questions_by_page[4], (q) => {
				return !q.is_bookmarked
			}))
			this.questions_to_display = this.questions_to_display.concat(this.questions)
		}
	},

	computed: {
		answersLengthes() {
			return Object.keys(AppStore.rating.questions_answers).length
		}
	},

	watch: {
		_() {
			return _;
		},
    questions_to_display: {
      handler(val) {
        this.$set(this.AppStore.questions_displayed_by_page, 4, val);
      },
      deep: true
    }
	},

	methods: {
		getBookmarkedQuestions() {
			this.questions_to_display = Object.assign([], AppStore.bookmarkedQuestions[4])
		},

		getRandomQuestions() {
			const max = AppStore.data.configuration.questions_to_display_4 - this.questions_to_display.length
			this.questions = Object.assign([], _.filter(AppStore.questions_by_page[4], (q) => {
				return !q.is_bookmarked
			}))

			for (let i = 0; i < max; i++) {
				const randomQuestionIndex = Math.floor(Math.random() * (this.questions.length));
				this.questions_to_display.push(this.questions[randomQuestionIndex]);
				this.questions.splice(randomQuestionIndex, 1)
			}
		},
		calculCguHeight() {
			if (AppStore.data.configuration.display_header_title_1) {
				const height = window.innerHeight - document.querySelector('#header').offsetHeight - document.querySelector('#footer').offsetHeight - 170 + 'px'
				document.getElementById("cgu-card").style.height = height;
			}
		},

		submit() {
			if (AppStore.data.configuration.skip_timeline_page) {
				this.$router.push({name: 'tb-3-home'})
			} else {
				this.$router.push({name: 'tb-3-timeline'})
			}

			EventBus.$emit('storeRating', 'noReset')
		},
	}
};
</script>
